<template>
  <div class="d-flex flex-column mt-2">
    <div class="conversa-workspace d-flex flex-row justify-content-between align-items-center my-2">
      <div class="conversa-workspace-header d-flex flex-column">
        <div class="conversa-workspace-header-title d-flex flex-row align-items-center">
          <div v-if="file_name_enabled || upload_enabled" class="d-flex align-items-center">
            <h5
              v-if="file_name_enabled"
              id="file_name"
              class="d-inline-block mr-3 mb-0 text-truncate">
              {{ file_name }}
            </h5>
            <div v-if="upload_enabled" id="upload_control">
              <input
                type="file"
                id="assetsFieldHandle"
                class="d-none"
                @change="handleChangeFile"
                ref="file"
                :accept="allowed_file_types"
              />
            </div>
          </div>
          <div v-if="showDocumentHeader" class="header-document">
            <documents-document-header-vue
                :header_fields="document_header_options.header_fields"
                :tituloarticulo="document_header_options.tituloarticulo"
                :document_id="document_id"
            />
          </div>
        </div>
        <div v-if="!isPdfFile" class="conversa-workspace-header-subtitle d-flex flex-row align-items-center">
          {{ t("components.sofia_file_analyzer.not_saved") }}
          <a class="conversa-workspace-header-subtitle-link ml-2" id="save-button" @click="handleSaveClick">
            {{ t("components.sofia_file_analyzer.save_button") }}
          </a>
        </div>
      </div>
      <div class="row align-items-center mx-0">
        <div class="btnSofia px-4 py-2" v-if="!showDocumentHeader && !isWorkspace">
          <label
            for="assetsFieldHandle"
            id="another_file_label"
            class="mb-3 mb-md-0 cursor-pointer d-flex align-items-center justify-content-center br-xl-1 pr-3">
            <span v-if="uploading_file" id="uploading_file" class="text-white">
              {{ t("components.sofia_file_analyzer.loading") }}
            </span>
            <span class="loader-general fileUp" v-if="uploading_file"></span>
            <span v-else id="another_file" class="text-nowrap">
              <i class="fas fa-cloud-upload-alt pr-2"></i>
              <span>{{ t("components.sofia_file_analyzer.another_file") }}</span>
            </span>
          </label>
          <div
            class="d-flex align-items-center justify-content-center cursor-pointer ml-3"
            @click="new_document()"
            id="new_document_button">
            <i class="fas fa-plus pr-2"></i>
            <label class="text-center mb-0 cursor-pointer" >{{
              t("sofia.sofia_uploader.new_document")
            }}</label>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mixins from 'common/mixins'
import { mapMutations } from 'vuex'
import SofiaUploaderMixin from "common/mixins/uploader_mixin";

export default {
  name: "sofia-toolbar-vue",
  mixins: [mixins.requests, mixins.translate, SofiaUploaderMixin],
  props: {
    options: { type: Array, default: () => [] },
    file_name: { type: String, default: "" },
    allowed_file_types: { type: String, default: "" },
    document_modified: { type: Boolean, default: false },
    document_header_options: { type: Object, default: () => { return {} } },
    document_id: { type: String, default: "" },
    mode: { type: String, default: 'default' }
  },
  components: {
    'documents-document-header-vue': () => import(/* webpackChunkName: "[request]" */ "../documents/DocumentHeader.vue")
  },
  computed: {
    file_name_enabled() {
      if (!this.options) return false
      return this.options.includes("file_name")
    },
    upload_enabled() {
      if (!this.options) return false
      return this.options.includes("upload")
    },
    showDocumentHeader(){
      return Object.keys(this.document_header_options).length > 0;
    },
    isWorkspace() {
      return this.mode === 'workspace'
    },
    isPdfFile() {
      return this.file_name && this.file_name.toLowerCase().endsWith('.pdf')
    },
  },

  methods: {
    handleSaveClick(event) {
      let conversationId = event && event.detail && event.detail.conversationId ? event.detail.conversationId : ''
      this.$emit("save_document:clicked", conversationId)
    },
    handleChangeFile(event) {
      let actual_file = event.target.files[0]
      this.update_current_file(actual_file)
    },
    ...mapMutations('sofia', ['update_current_file']),
  },
  mounted() {
    this._saveHandler = (event) => { this.handleSaveClick(event) }
    window.addEventListener("save_document:clicked", this._saveHandler)
  },
  beforeDestroy() {
    window.removeEventListener("save_document:clicked", this._saveHandler)
  }
}
</script>
